var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-component',{key:_vm.refreshKey,attrs:{"value":_vm.value,"model":_vm.model,"module":_vm.module},on:{"input":function($event){return _vm.$emit('input', $event)},"close":_vm.handleClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }